import styled from 'styled-components';

export const NavIconContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: max-content;
`;
